import { createSelector } from 'reselect'

import { selectState } from './selectState'

export const selectJBPSettings = createSelector([selectState], (state) => state.data)
